module.exports = __webpack_public_path__ + "media/images/icons/ico-pen-de3fbda4a60042f23bb709b93260dad7.svg";